import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  ViewEncapsulation,
  booleanAttribute,
  input,
  viewChild,
} from '@angular/core';
import { NgChanges } from '../../utilities/angular-types.util';
import { LoadingIndicator } from '../loading-indicator/loading-indicator.component';
import { Paginator } from '../paginator/paginator.component';

@Component({
  selector: 'procure-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
  imports: [LoadingIndicator, Paginator],
  encapsulation: ViewEncapsulation.None,
})
export class Table implements OnChanges {
  @Input() dataSourceTotalLength: number = 0;
  @Input() dataSourceLength: number = 0;
  @Input({ transform: booleanAttribute }) isLoading: boolean = false;
  @Input({ transform: booleanAttribute }) hidePagination: boolean = false;
  @Input({ transform: booleanAttribute }) disableAllOption!: boolean;
  @Input() pageSizes: number[] = [10, 20, 50];

  readonly scrollContainer = viewChild<ElementRef>('scrollContainer');
  readonly paginator = viewChild.required(Paginator);

  readonly verticalScroll = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly fullHeight = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  protected scrollIndicatorRight: boolean = false;
  protected scrollIndicatorLeft: boolean = false;

  ngOnChanges(changes: NgChanges<Table>): void {
    if (changes.isLoading?.currentValue) {
      this.scrollIndicators();
    }
  }

  scrollIndicators(): void {
    const scrollContainer = this.scrollContainer();
    const element: HTMLElement = scrollContainer?.nativeElement;

    if (scrollContainer && element.scrollWidth > element.clientWidth) {
      this.scrollIndicatorRight =
        element.scrollLeft < element.scrollWidth - element.clientWidth;
      this.scrollIndicatorLeft = element.scrollLeft > 0;
    } else {
      this.scrollIndicatorRight = false;
      this.scrollIndicatorLeft = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  protected onResize(_event: UIEvent): void {
    this.scrollIndicators();
  }
}
